import { Fragment } from "react";
import ToolsCard from "./toolsCard";
import CalculatorIcon from "../../icons/calculatorIcon";
import ClipBoardIcon from "../../icons/clipBoardIcon";
import ScrollIcon from "../../icons/scrollIcon";
import TaskIcon from "../../icons/taskIcon";
import TruckIcon from "../../icons/truckIcon";
import BoxIcon from "../../icons/boxIcon";
import NetworkIcon from "../../icons/networkIcon";
import { useTranslation } from "react-i18next";

const Tools = () => {
  const { t } = useTranslation();
  const tools = [
    {
      icon: <CalculatorIcon />,
      header: t("shippingCalculators"),
      description: t("avoidExtraCharges"),
      link: "/tools/shipping-calculators",
    },
    {
      icon: <ClipBoardIcon />,
      header: t("customTariffs"),
      description: t("makeSureYourGoods"),
      link: "/tools/customs-tariffs",
    },
    {
      icon: <ScrollIcon />,
      header: t("customsDutyCalculator"),
      description: t("findOutTheCustomsDuties"),
      link: "/tools/customs-duty",
    },
    {
      icon: <TaskIcon />,
      header: t("customClearance"),
      description: t("weCarryCustomsClearanceOperations"),
      link: "/tools/customs-clearance",
    },
    {
      icon: <TruckIcon fill="#0051FF" />,
      header: t("truckTypes"),
      description: t("learnAboutTrucks"),
      link: "/tools/truck-types",
    },
    {
      icon: <BoxIcon />,
      header: t("containerTypes"),
      description: t("understandContainers"),
      link: "/tools/container-types",
    },
    {
      icon: <NetworkIcon fill="#0051FF" />,
      header: t("incoterms"),
      description: t("wePresentTheMost"),
      link: "/tools/international-terms",
    },
  ];
  return (
    <main>
      <article className="py-20">
        <div className="w-11/12 mx-auto">
          <h1 className="text-[24px] md:text-[32px] font-bold text-mainBlue text-center">
            {t("ourTools")}
          </h1>
          <p className="text-lg text-mainGray text-center mx-auto max-w-[800px] my-10">
            {t("weSupportClientsWithValuableTools")}
          </p>
          <section className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
            {tools.map((tool, i) => (
              <Fragment key={i}>
                <ToolsCard tool={tool} />
              </Fragment>
            ))}
          </section>
        </div>
      </article>
    </main>
  );
};

export default Tools;
